import React, { useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
import Sliders from '../Sliders';
import './slider.scss';
// import Modal from '../elements/Modal';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
} 

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
              REMA Experts <span className="text-color-primary">In Nigeria</span>
            </h1>
            <div className="container-xs">
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                REMA is a subsidiary of Sydneynels Enterprise dedicated to getting you high skilled experts for maintenance and repairs (Facility Management).
                </p>
                <div className='container mt-5 carousel slide-body'>
                  <h1 className='slider_title'>Our Services</h1>
                  
                </div>
              <div className="reveal-from-bottom" data-reveal-delay="600" style={{marginBottom: '50px',}}>
                <ButtonGroup>
                  <Link to='/login'>
                    <Button to='/Login' tag="a" color="primary" wideMobile href="">
                    Get In Touch
                    </Button>
                  </Link>
                  {/* <Button tag="a" color="dark" wideMobile href="https://github.com/cruip/open-react-template/">
                    View on Github
                    </Button> */}
                </ButtonGroup>
              </div>
            </div>
          </div>
          <Sliders className="slide-body" />
          <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800" style={{marginTop: '50px',}}>
            <a
              // data-video="https://player.vimeo.com/video/174002812"
              // href="#0"
              // aria-controls="video-modal"
              // onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/images/bg1.jpg')}
                alt="Hero"
                width={896}
                height={504} />
            </a>
          </div>
          {/* <Modal
            id="video-modal"
            show={videoModalActive}
            handleClose={closeModal}
            video="https://player.vimeo.com/video/174002812"
            videoTag="iframe" /> */}
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;